import useQueryReport from "@/hooks/queries/useQueryReport";
import { CircularProgress } from "@mui/material";
import React from "react";
import { Styled } from "./styles";
import withErrorBoundary from "@/components/hoc/withErrorBoundary";
import Form from "@/components/report";

const Report: React.FC = () => {
    const { data, isLoading } = useQueryReport();

    if (isLoading || !data) {
        return (
            <Styled.Page center={true}>
                <CircularProgress></CircularProgress>
            </Styled.Page>
        );
    }

    return (
        <Styled.Page sx={{ padding: "0px 0px 100px 0px" }}>
            <Form data={data} />
        </Styled.Page>
    );
};

export default withErrorBoundary({ component: "Report page" })(Report);
